import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "clockForwards"
const ClockForwardsIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M8.686 2.31C11.102 1.579 13.705 1.776 15.983 2.863 17.448 3.56 18.71 4.596 19.678 5.867V3.75H21.179V9.366H16.5V7.865L19.19 7.864C18.326 6.28 16.982 4.999 15.338 4.215 13.397 3.29 11.18 3.122 9.121 3.746 7.063 4.371 5.312 5.742 4.213 7.59S2.743 11.63 3.176 13.737 4.816 17.713 6.555 18.977 10.445 20.81 12.582 20.573C14.72 20.332 16.691 19.304 18.11 17.687S20.29 13.982 20.249 11.831L21.747 11.803C21.797 14.327 20.902 16.78 19.237 18.677S15.257 21.783 12.748 22.063 7.716 21.675 5.673 20.19C3.631 18.706 2.216 16.513 1.707 14.04S1.633 8.993 2.924 6.823C4.214 4.653 6.27 3.043 8.686 2.311" />
          <path d="M10.875 6.75C11.703 6.75 12.375 7.422 12.375 8.25V11.69L14.47 13.784C15.055 14.37 15.055 15.32 14.47 15.905L10.875 12.311z" />
        </svg>
      }
    </span>
  )
}
export default ClockForwardsIcon
